import { useFormContext } from 'react-hook-form';
import {
  Address,
  Date,
  Divider,
  DropDown,
  Email,
  FileUpload,
  Heading,
  Link,
  LongText,
  MultipleChoice,
  MultiSelect,
  Name,
  PhoneNumber,
  SingleChoice,
  Time,
  Number,
  ShortText,
  Paragraph,
  Boolean,
  Currency,
  PracticeArea,
  RelationField,
  Role,
  DateWithoutTimezoneField,
  PreviewSignature,
} from '../pageElements';
import { evaluateConditions } from 'utils/utils';

export const RenderContent = ({ condition, props = {}, className = '' }) => {
  const { watch } = useFormContext();
  const fields = watch('form_data');

  if (props.isFormBuilder !== true && !evaluateConditions(fields, props.item)) {
    return <></>;
  }

  return (
    <div className={`w-100 ${className}`}>
      {condition === 'short' || condition === 'Text(short)' ? (
        <ShortText {...props} />
      ) : condition === 'long' || condition === 'Text(long)' ? (
        <LongText {...props} />
      ) : condition === 'number' || condition === 'Number' ? (
        <Number {...props} />
      ) : condition === 'phone' ? (
        <PhoneNumber {...props} />
      ) : condition === 'email' ? (
        <Email {...props} />
      ) : condition === 'address' ? (
        <Address {...props} />
      ) : condition === 'date_without_timezone' || condition === 'DOB' ? (
        <DateWithoutTimezoneField {...props} />
      ) : condition === 'date' || condition === 'Date' ? (
        <Date {...props} />
      ) : condition === 'heading' ? (
        <Heading {...props} />
      ) : condition === 'time' ? (
        <Time {...props} />
      ) : condition === 'dropdown' || condition === 'List' ? (
        <DropDown {...props} />
      ) : condition === 'multiselect' ? (
        <MultiSelect {...props} />
      ) : condition === 'divider' ? (
        <Divider {...props} />
      ) : condition === 'link' ? (
        <Link {...props} />
      ) : condition === 'multiplechoice' ? (
        <MultipleChoice {...props} />
      ) : condition === 'name' ? (
        <Name {...props} />
      ) : condition === 'singlechoice' ? (
        <SingleChoice {...props} />
      ) : condition === 'paragraph' ? (
        <Paragraph {...props} />
      ) : condition === 'Boolean' ? (
        <Boolean {...props} />
      ) : condition === 'Currency' ? (
        <Currency {...props} />
      ) : condition === 'practice_area' ? (
        <PracticeArea {...props} />
      ) : condition === 'relation' ? (
        <RelationField {...props} />
      ) : condition === 'role' ? (
        <Role {...props} />
      ) : condition === 'signature' ? (
        <PreviewSignature {...props} />
      ) : condition === 'file' ? (
        <FileUpload {...props} />
      ) : null}
    </div>
  );
};
